<template>
  <div>
    <form-navigation-tabs
      :tabs="tabs"
      v-on:selected="setActive"
      :active="currentView"
      :enable-logging="true"
      :incident="incident"
      :module="module"
      :parentTabs="['Third Parties']"
      class="margin-t-10"
    ></form-navigation-tabs>

    <third-party-details
      :incident="incident"
      :third-party="thirdParty"
      :readonly="readonly"
      v-if="currentView == 'details'"
      @unsaved-data="emitSaveStatus"
      @has-third-party="hasThirdParty"
      @remove-third-party="removeThirdParty"
    ></third-party-details>

    <third-party-vehicle
      :incident="incident"
      :third-party="thirdParty"
      :readonly="readonly"
      v-if="currentView == 'vehicle'"
      @unsaved-data="emitSaveStatus"
      @remove-third-party="removeThirdParty"
    ></third-party-vehicle>

    <third-party-occupants
      :incident="incident"
      :third-party="thirdParty"
      :readonly="readonly"
      @remove-third-party="removeThirdParty"
      v-if="currentView == 'third-party-occupants'"
    ></third-party-occupants>
  </div>
</template>
<script>
import ThirdPartyDetails from './ThirdPartyDetails.vue';
import ThirdPartyVehicle from './ThirdPartyVehicle.vue';
import ThirdPartyOccupants from './ThirdPartyOccupants';
import thirdParty from '@/components/Modules/Qualification/Sections/Party/ThirdParty';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    module: {
      type: String,
      required: true
    },
    thirdParty: {
      type: Object,
      required: true
    },
    tab: String,
    readonly: {
      type: Boolean,
      default: false
    }
  },

  components: {
    'third-party-occupants': ThirdPartyOccupants,
    'third-party-details': ThirdPartyDetails,
    'third-party-vehicle': ThirdPartyVehicle
  },

  data() {
    return {
      currentView: 'details',
      unsaved_data: false,
      tabs: [
        {
          name: 'details',
          label: 'Details',
          disabled: false
        },
        {
          name: 'vehicle',
          label: 'Vehicle',
          disabled: true
        },
        {
          name: 'third-party-occupants',
          label: 'Occupants',
          disabled: true
        }
      ],
      has_third_party: false
    };
  },

  mounted() {
    this.mount();
  },

  methods: {
    mount() {
      if (this.tab) {
        this.currentView = this.tab;
      }

      if (this.thirdParty && this.thirdParty.identifier) {
        this.has_third_party = true;
      }
    },

    hasThirdParty(value) {
      this.has_third_party = value;
    },

    emitSaveStatus(value) {
      this.unsaved_data = value;

      this.$emit('unsaved-data', value);
    },

    setActive(tab) {
      // check if unsaved data on the current form
      if (this.unsaved_data && this.currentView !== tab) {
        this.saveWarning(tab); // show alert if there is
      } else {
        this.currentView = tab;

        this.$emit('tab', tab);
      }
    },

    saveWarning(tab) {
      window
        .swal({
          title: 'Are you sure?',
          text:
            'You will lose all details entered in this section if you continue!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Continue without saving',
          cancelButtonText: 'Cancel and stay in this section'
        })
        .then(
          () => {
            // Go to selected tab discarding changes
            this.currentView = tab;
            this.unsaved_data = false;
          },
          dismiss => {}
        );
    },

    removeThirdParty() {
      if (this.readonly) return;
      window
        .swal({
          title: 'Are you sure?',
          text: 'Are you sure you want to remove that third party?',
          type: 'warning',
          showCancelButton: true
        })
        .then(() => {
          window.Ajax.delete(
            `/incidents/${this.incident}/third-parties/${this.thirdParty.identifier}`
          )
            .then(() => {
              this.$emit('remove-third-party', this.thirdParty);

              window.toastify.success(
                'Removed',
                'The third party was removed!'
              );
            })
            .catch(err => {
              window.toastify.error(
                'Error',
                'Oops, there was an error deleting the third party'
              );
            });
        })
        .catch(err => {});
    }
  },
  watch: {
    has_third_party() {
      if (this.has_third_party) {
        this.tabs.forEach(tab => (tab.disabled = false));
      }
    }
  }
};
</script>
